import {
  Box,
  Typography,
  Link,
  Divider,
  Stack,
} from '@mui/material';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';

export default function ContactUs() {
  const supportEmail = 'support@hy-gro.co.uk';
  const discordInvite = 'https://discord.gg/D6enDyU6wR';
  const bugReportForm = 'https://docs.google.com/forms/d/e/1FAIpQLSfgxEhD8rtiUrBsUShac8IFZ9dzXZgf3m_7n9Svw8tmbx-sIg/viewform?usp=header'; // Replace with your form link

  return (
    <Box
      sx={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '20px',
        backgroundColor: (theme) => theme.palette.background.default,
        color: (theme) => theme.palette.text.primary,
      }}
    >
      <Typography variant="h4" gutterBottom>
        Contact Us &amp; Bug Reports
      </Typography>
      <Divider sx={{ width: '100%', my: 2 }} />

      <Typography variant="body1" paragraph>
        Have a question, found a bug, or want to chat with the community? Here’s how to reach us:
      </Typography>

      <Stack spacing={3} sx={{ maxWidth: 800, m: '0 auto', p: 2 }}>

        <Box>
          <Typography variant="h6" gutterBottom>
            🐞 Report a Bug
          </Typography>
          <Typography variant="body2" paragraph>
            You can report bugs through our quick form, or chat with us directly on Discord.
          </Typography>
          <Stack spacing={1}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <BugReportOutlinedIcon color="error" />
              <Link
                href={bugReportForm}
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                variant="body1"
              >
                Fill out the Bug Report Form
              </Link>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <ForumOutlinedIcon color="primary" />
              <Link
                href={discordInvite}
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                variant="body1"
              >
                Report bugs in Discord
              </Link>
            </Box>
          </Stack>
        </Box>

        <Box>
          <Typography variant="h6" gutterBottom>
            ✉️ General Enquiries
          </Typography>
          <Typography variant="body2" paragraph>
            For anything else-questions, support, or feedback-you can email us.
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <EmailOutlinedIcon color="action" />
            <Link
              href={`mailto:${supportEmail}`}
              underline="hover"
              variant="body1"
            >
              {supportEmail}
            </Link>
          </Box>
        </Box>

      </Stack>
    </Box>
  );
}
